module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h6', {
    staticClass: "text-center",
    attrs: {
      "for": "amount"
    }
  }, [_vm._v("最大庫存")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    ref: "input",
    staticClass: "form-control custom-input",
    attrs: {
      "id": "amount",
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "click": function($event) {
        _vm.showPad = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showPad) ? _c('NumberInput', {
    attrs: {
      "defaultNumber": _vm.amount
    },
    on: {
      "saveNumber": _vm.saveNumber
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h6', {
    staticClass: "text-center",
    attrs: {
      "for": "patch"
    }
  }, [_vm._v("批號")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patchNumber),
      expression: "patchNumber"
    }],
    staticClass: "form-control custom-input",
    attrs: {
      "id": "patchnumber",
      "placeholder": _vm.placeholderText
    },
    domProps: {
      "value": (_vm.patchNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.patchNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button-wrap"
  }, [_c('button', {
    staticClass: "btn btn-lg confirm-button",
    on: {
      "click": _vm.setMaxAmountData
    }
  }, [_vm._v("確認")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4edaa708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/MaxStockSet.vue
// module id = 1472
// module chunks = 1